export default __webpack_public_path__ + "static/media/twizzer.cbbb81fc.png";